import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetAtom } from "jotai";
import Cookies from "js-cookie";

import {
  queriesEnabledAtom,
  userRecordActivityAtom,
} from "../../../atoms/GlobalAtoms";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import API from "../../api/API";

const useLogout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setQueriesEnabled = useSetAtom(queriesEnabledAtom);
  const setWorkspaceID = useSetAtom(workspaceIdAtom);
  const setUserRecordActivity = useSetAtom(userRecordActivityAtom);
  const queryClient = useQueryClient();

  // Logout the user
  const logout = useMutation({
    mutationFn: async (props: {
      useRedirect?: boolean;
      onSuccess?: () => void;
    }) => {
      const useRedirect = props?.useRedirect;
      const onSuccess = props?.onSuccess;
      queryClient.getQueryCache().clear();

      const currentLocation = location?.pathname;
      setWorkspaceID(null);

      navigate(
        `/login${
          useRedirect && currentLocation
            ? !currentLocation.includes("login")
              ? `?r=${currentLocation}`
              : ""
            : ""
        }`
      );

      return API.deleteSession()
        .then(() => callFunctionIfExists(onSuccess))
        .catch((err) => console.log(err.response))
        .finally(() => {
          setQueriesEnabled(false);
          setUserRecordActivity(false);

          queryClient.removeQueries({
            queryKey: ["userRecordActivity"],
          });

          Object.keys(Cookies.get()).forEach(function (cookieName) {
            const neededAttributes: any = { sameSite: "strict", secure: true };
            Cookies.remove(cookieName, neededAttributes);
          });
        });
    },
  });

  return {
    logout: logout.mutate,
    logoutLoading: logout.isPending,
  };
};

export default useLogout;
